import { render, staticRenderFns } from "./GiveOuts.vue?vue&type=template&id=3aa1bfd2"
import script from "./GiveOuts.vue?vue&type=script&lang=js"
export * from "./GiveOuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports